import React from 'react'
import logo from '../../assets/icons/logo-black.svg'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import icon from '../../assets/icons/step-white.svg'
import icon_black from '../../assets/icons/step-black.svg'
import arrow from '../../assets/icons/arrow-link.svg'
import arrow_red from '../../assets/icons/arrow-link-red.svg'
import instagram from '../../assets/icons/instagram.svg'
import whatsapp from '../../assets/icons/whatsapp.svg'
import { useModal } from '../common/ModalContext'

function Footer2() {
	const {t} = useTranslation()
    const {openModal} = useModal()

	return (
		<footer className='bg-[#0E0E0E] py-16 lg:py-20 mt-20'>
			<div className='container mx-auto'>
				<div className='flex flex-col space-y-16'>
                    <div className='grid grid-cols-1 sm:grid-cols-2 items-start gap-12'>
                        <div className='flex flex-col items-start space-y-6'>
                            <h2 className='font-title text-white font-semibold text-3xl lg:text-5xl'>Свяжитесь с нами</h2>
                            <p className='text-lg font-light text-white'>Напишите нам по поводу проекта, мы свяжемся<br/>с вами для детального обсуждения</p>
                            <button onClick={openModal} className='flex items-center space-x-2 justify-center btn-primary px-8 py-3 bg-[#FF4548] text-white hover:bg-white hover:text-black hover:border-[#FF4548] border group border-black transition-all duration-300 ease-in-out'>
                                <span className='text-lg'>{t('navbar.order')}</span>
                                <img className='group-hover:hidden' src={icon} width={16} />
                                <img className='hidden group-hover:block' src={icon_black} width={16} />
                            </button>
                        </div>
                        <div className="grid grid-cols-2 lg:grid-cols-3 gap-6">
                            <div className="flex flex-col space-y-3">
                                <Link to="/services" className="text-bg md:text-lg font-light">
                                {t('navbar.services')}
                                </Link>
                                <Link to="/cases" className="text-bg md:text-lg font-light">
                                {t('navbar.cases')}
                                </Link>
                                <Link to="/vacancies" className="text-bg md:text-lg font-light">
                                {t('navbar.vacancies')}
                                </Link>
                            </div>

                            <div className="flex flex-col space-y-3 lg:mt-0">
                                <Link to="/services#branding" className="text-bg md:text-lg font-light">
                                {t('navbar.services-drop.branding')}
                                </Link>
                                <Link to="/services#digup" className="text-bg md:text-lg font-light">
                                {t('navbar.services-drop.digap')}
                                </Link>
                                <Link to="/services#promote" className="text-bg md:text-lg font-light">
                                {t('navbar.services-drop.promotion')}
                                </Link>
                                <a
                                href="mailto:hello@aigla.kz"
                                className="block lg:hidden text-bg md:text-lg font-light"
                                >
                                hello@aigla.kz
                                </a>
                            </div>

                            <div className="hidden lg:block mt-6 md:mt-0">
                                <a
                                href="mailto:hello@aigla.kz"
                                className="text-bg md:text-lg font-light"
                                >
                                hello@aigla.kz
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-12'>
                        <div>
                            <p className='text-xl text-white'>
                            AIgla — создаем бренды, которые меняют рынок
                            </p>
                        </div>
                        <div className='grid grid-cols-2 lg:grid-cols-3 w-full gap-6'>
                            <a className='flex items-center space-x-2 group' href="mailto:hello@aigla.kz" target='_blank'>
                                <p className='text-white text-3xl group-hover:text-[#FF4548]'>Почта</p>
                                <img className='group-hover:hidden' src={arrow} width={20} />
                                <img className='hidden group-hover:block' src={arrow_red} width={20} />
                            </a>
                            <a className='flex items-center space-x-2 group' href='https://wa.me/77052221923' target='_blank'>
                                <p className='text-white text-3xl group-hover:text-[#FF4548]'>Ватсап</p>
                                <img className='group-hover:hidden' src={arrow} width={20} />
                                <img className='hidden group-hover:block' src={arrow_red} width={20} />
                            </a>
                            <a className='flex items-center space-x-2 group' href='https://t.me/+77052221923' target='_blank'>
                                <p className='text-white text-3xl group-hover:text-[#FF4548]'>Телеграм</p>
                                <img className='group-hover:hidden' src={arrow} width={20} />
                                <img className='hidden group-hover:block' src={arrow_red} width={20} />
                            </a>
                        </div>
                    </div>
                    <div className='flex flex-col space-y-6'>
                        <img src={logo} className='w-full' />
                        <div className='flex items-center flex-wrap gap-6 justify-between'>
                            <div className='text-lightGray md:text-lg'>{t('copyright')}</div>
                            <div className='flex flex-wrap items-center gap-6'>
                                <div className='text-lightGray md:text-lg'>{t('policy')}</div>
                                <div className='text-lightGray md:text-lg'>{t('privacy')}</div>
                            </div>
                        </div>
                    </div>
                </div>
			</div>
		</footer>
	)
}

export default Footer2